<section class="kb-card">
  <div class="kb-card-header">
    <div class="flex items-center justify-between gap-2">
      <h3 class="kb-card-title">Lo que ve el cliente</h3>
      <div class="kb-tabs" role="group" aria-label="Vista del teléfono">
        <button type="button" class="kb-tab" [ngClass]="{'kb-tab-activo': modo === 'hoy'}" (click)="modoChange.emit('hoy')">Hoy</button>
        <button type="button" class="kb-tab" [ngClass]="{'kb-tab-activo': modo === 'borrador'}" (click)="modoChange.emit('borrador')">Con tus cambios</button>
      </div>
    </div>
  </div>
  <div class="kb-card-body">
    <div class="telefono" aria-live="polite" id="telefono-cliente">
      <div class="telefono-muesca" aria-hidden="true"></div>
      <div class="telefono-titulo">¿Cómo quieres pagar?</div>

      <div *ngFor="let o of vista.opciones" class="telefono-opcion" [ngClass]="{'telefono-entra': o.marca === 'entra', 'telefono-sale': o.marca === 'sale'}">
        <div class="flex items-center justify-between gap-2">
          <span class="telefono-opcion-titulo">{{ o.titulo }}</span>
          <span *ngIf="o.marca === 'entra'" class="kb-badge kb-badge-exito">entra</span>
          <span *ngIf="o.marca === 'sale'" class="kb-badge kb-badge-peligro">sale</span>
        </div>
        <div *ngIf="o.texto" class="telefono-texto">{{ o.texto }}</div>

        <ng-container *ngIf="o.marca !== 'sale'">
          <ng-container *ngFor="let p of o.partes">
            <div class="telefono-sub">{{ p.metodo }}</div>
            <div *ngFor="let i of p.items" class="telefono-cuenta" [ngClass]="{'telefono-entra': i.marca === 'entra', 'telefono-sale': i.marca === 'sale'}">
              <div class="flex items-center justify-between gap-2">
                <span class="font-medium">{{ i.banco }}</span>
                <span *ngIf="i.marca === 'entra'" class="kb-badge kb-badge-exito">entra</span>
                <span *ngIf="i.marca === 'sale'" class="kb-badge kb-badge-peligro">sale</span>
              </div>
              <div *ngIf="i.dato" class="telefono-dato">{{ i.dato }}</div>
              <div class="telefono-dato">{{ i.titular }}</div>
            </div>
          </ng-container>
          <div *ngIf="o.cobra" class="telefono-dato">{{ o.cobra }}</div>
          <div *ngIf="o.fallan" class="kb-caja-alerta mt-2 rounded-md border p-2 text-xs">Fallaría: {{ o.fallan.join(', ') }} sin cuenta del contrato que cobra.</div>
          <div *ngIf="o.vacia" class="kb-caja-alerta mt-2 rounded-md border p-2 text-xs">Sin cuentas: se abriría vacía.</div>
        </ng-container>
      </div>

      <div *ngIf="!vista.opciones.length" class="kb-caja-alerta rounded-md border p-3 text-sm">Ninguna opción de pago visible.</div>
    </div>
    <p class="mt-3 text-xs text-muted-foreground">
      {{ modo === 'borrador' ? 'Así quedaría al guardar. «Entra» y «sale» comparan con hoy.' : 'Así lo ve el cliente ahora mismo.' }}
      <span *ngIf="modo === 'borrador' && vista.reordenada"> El orden de las opciones cambió.</span>
      <span *ngIf="modo === 'borrador' && !hayCambios"> Todavía no hay cambios: es igual a hoy.</span>
      Las etiquetas nunca se muestran al cliente.
    </p>
  </div>
</section>
